// import React, { useEffect, useState } from "react";
// import Cookies from "js-cookie";

// import SummaryCards from "./SummaryCards";
// import TopFarmers from "./TopFarmers";
// import DailyTrendChart from "./DailyTrendChart";

// export default function RecordsSummaryPage() {
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const adminCookie =
//       Cookies.get("sessionidadmin");

//     if (!adminCookie) {
//       setLoading(false);
//       return;
//     }

//     fetch(
//       "https://api.mysite.africa/getDailyRecords",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type":
//             "application/json",
//         },
//         body: JSON.stringify({
//           adminid: adminCookie,
//         }),
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (Array.isArray(data)) {
//           setRecords(data);
//         }

//         setLoading(false);
//       })
//       .catch(() => {
//         setLoading(false);
//       });
//   }, []);

//   const now = new Date();

//   const currentMonthRecords =
//     records.filter((record) => {
//       const d = new Date(
//         record.daterecorded
//       );

//       return (
//         d.getMonth() ===
//           now.getMonth() &&
//         d.getFullYear() ===
//           now.getFullYear()
//       );
//     });


//     const currentYearRecords =
//   records.filter((record) => {
//     const d = new Date(
//       record.daterecorded
//     );

//     return (
//       d.getFullYear() ===
//       now.getFullYear()
//     );
//   });

// const yearlyEntries =
//   currentYearRecords.length;

// const yearlyWeight =
//   currentYearRecords.reduce(
//     (sum, record) =>
//       sum +
//       Number(record.weight || 0),
//     0
//   );

// const yearlyApproved =
//   currentYearRecords.filter(
//     (record) =>
//       record.approved_status ===
//       "approved"
//   ).length;

// const yearlyPending =
//   currentYearRecords.filter(
//     (record) =>
//       record.approved_status !==
//       "approved"
//   ).length;

//   const allTimeEntries =
//   records.length;

// const allTimeWeight =
//   records.reduce(
//     (sum, record) =>
//       sum +
//       Number(record.weight || 0),
//     0
//   );

// const allTimeApproved =
//   records.filter(
//     (record) =>
//       record.approved_status ===
//       "approved"
//   ).length;

// const allTimePending =
//   records.filter(
//     (record) =>
//       record.approved_status !==
//       "approved"
//   ).length;

//   const previousMonthRecords =
//     records.filter((record) => {
//       const d = new Date(
//         record.daterecorded
//       );

//       const prevMonth =
//         now.getMonth() === 0
//           ? 11
//           : now.getMonth() - 1;

//       const prevYear =
//         now.getMonth() === 0
//           ? now.getFullYear() - 1
//           : now.getFullYear();

//       return (
//         d.getMonth() === prevMonth &&
//         d.getFullYear() === prevYear
//       );
//     });

//   const monthlyEntries =
//     currentMonthRecords.length;

//   const monthlyWeight =
//     currentMonthRecords.reduce(
//       (sum, record) =>
//         sum +
//         Number(record.weight || 0),
//       0
//     );

//   const approvedCount =
//     currentMonthRecords.filter(
//       (record) =>
//         record.approved_status ===
//         "approved"
//     ).length;

//   const pendingCount =
//     currentMonthRecords.filter(
//       (record) =>
//         record.approved_status !==
//         "approved"
//     ).length;

//   const approvalRate =
//     monthlyEntries > 0
//       ? (approvedCount /
//           monthlyEntries) *
//         100
//       : 0;

//   const previousWeight =
//     previousMonthRecords.reduce(
//       (sum, record) =>
//         sum +
//         Number(record.weight || 0),
//       0
//     );

//   const growthPercentage =
//     previousWeight > 0
//       ? (
//           ((monthlyWeight -
//             previousWeight) /
//             previousWeight) *
//           100
//         )
//       : 0;

//   const farmerMap = {};

//   currentMonthRecords.forEach(
//     (record) => {
//       if (
//         !farmerMap[
//           record.fullname
//         ]
//       ) {
//         farmerMap[
//           record.fullname
//         ] = 0;
//       }

//       farmerMap[
//         record.fullname
//       ] += Number(
//         record.weight || 0
//       );
//     }
//   );

//   const topFarmers =
//     Object.entries(
//       farmerMap
//     )
//       .map(
//         ([fullname, weight]) => ({
//           fullname,
//           weight,
//         })
//       )
//       .sort(
//         (a, b) =>
//           b.weight - a.weight
//       )
//       .slice(0, 10);

//   if (loading) {
//     return (
//       <div className="pa4">
//         Loading...
//       </div>
//     );
//   }

//   return (
//     <div className="pa3 mt5">

//       <h1 className="f2 mb4">
//         Records Summary
//       </h1>

//       <SummaryCards
//         monthlyEntries={
//           monthlyEntries
//         }
//         monthlyWeight={
//           monthlyWeight
//         }
//         approvedCount={
//           approvedCount
//         }
//         pendingCount={
//           pendingCount
//         }
//         approvalRate={
//           approvalRate
//         }
//         growthPercentage={
//           growthPercentage
//         }
//       />
// {/* YEARLY SUMMARY */}
// <div className="mt4">
//   <h2 className="f3 mb3">
//     Yearly Summary
//   </h2>

//   <div className="flex flex-wrap">

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Yearly Records</div>
//         <div className="f2 fw6">{yearlyEntries}</div>
//       </article>
//     </div>

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Yearly Weight</div>
//         <div className="f2 fw6">
//           {yearlyWeight.toFixed(2)}
//         </div>
//       </article>
//     </div>

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Approved</div>
//         <div className="f2 fw6 green">
//           {yearlyApproved}
//         </div>
//       </article>
//     </div>

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Pending</div>
//         <div className="f2 fw6 orange">
//           {yearlyPending}
//         </div>
//       </article>
//     </div>

//   </div>
// </div>

// {/* ALL TIME SUMMARY */}
// <div className="mt4">
//   <h2 className="f3 mb3">
//     All-Time Summary
//   </h2>

//   <div className="flex flex-wrap">

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Total Records</div>
//         <div className="f2 fw6">
//           {allTimeEntries}
//         </div>
//       </article>
//     </div>

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Total Weight</div>
//         <div className="f2 fw6">
//           {allTimeWeight.toFixed(2)}
//         </div>
//       </article>
//     </div>

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Approved</div>
//         <div className="f2 fw6 green">
//           {allTimeApproved}
//         </div>
//       </article>
//     </div>

//     <div className="w-100 w-50-m w-25-l pa2">
//       <article className="bg-white shadow-4 br3 pa3 tc">
//         <div className="gray">Pending</div>
//         <div className="f2 fw6 orange">
//           {allTimePending}
//         </div>
//       </article>
//     </div>

//   </div>
// </div>

//     <TopFarmers
//   farmers={topFarmers}
// />

// <DailyTrendChart
//   records={currentMonthRecords}
// />

//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

export default function UserSummaryPage({ userid }) {
  const [profile, setProfile] = useState(null);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userCookie = Cookies.get("sessioniduser");

    if (!userCookie) {
      setLoading(false);
      return;
    }

    fetch("https://api.terraweb.africa/getRecords", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userid: userCookie,
        // userid,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.profile) {
          setProfile(data.profile);
        }

        if (Array.isArray(data?.records)) {
          setRecords(data.records);
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [userid]);

  const now = new Date();

  const currentMonthRecords = records.filter((record) => {
    const d = new Date(record.daterecorded);
    return (
      d.getMonth() === now.getMonth() &&
      d.getFullYear() === now.getFullYear()
    );
  });

  const previousMonthRecords = records.filter((record) => {
    const d = new Date(record.daterecorded);
    const prevMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
    const prevYear =
      now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
    return d.getMonth() === prevMonth && d.getFullYear() === prevYear;
  });

  const totalEntries = records.length;

  const totalWeight = records.reduce(
    (sum, record) => sum + Number(record.weight || 0),
    0
  );

  const approvedCount = records.filter(
    (record) => record.approved_status === "approved"
  ).length;

  const pendingCount = records.filter(
    (record) => record.approved_status !== "approved"
  ).length;

  const approvalRate =
    totalEntries > 0 ? (approvedCount / totalEntries) * 100 : 0;

  const monthlyWeight = currentMonthRecords.reduce(
    (sum, record) => sum + Number(record.weight || 0),
    0
  );

  const previousWeight = previousMonthRecords.reduce(
    (sum, record) => sum + Number(record.weight || 0),
    0
  );

  const growthPercentage =
    previousWeight > 0
      ? ((monthlyWeight - previousWeight) / previousWeight) * 100
      : 0;

  const productMap = {};

  records.forEach((record) => {
    const key = record.producttype || "Unspecified";

    if (!productMap[key]) {
      productMap[key] = { entries: 0, weight: 0 };
    }

    productMap[key].entries += 1;
    productMap[key].weight += Number(record.weight || 0);
  });

  const productBreakdown = Object.entries(productMap)
    .map(([producttype, stats]) => ({ producttype, ...stats }))
    .sort((a, b) => b.weight - a.weight);

  const recentRecords = [...records]
    .sort((a, b) => new Date(b.daterecorded) - new Date(a.daterecorded))
    .slice(0, 10);

  if (loading) {
    return <div className="pa4">Loading...</div>;
  }

  if (!profile) {
    return <div className="pa4">No profile found.</div>;
  }

  return (
    <div className="pa3 mt5">
      <ProfileHeader profile={profile} />

      <div className="mt4">
        <h2 className="f3 mb3">Summary</h2>

        <div className="flex flex-wrap">
          <StatCard label="Total Records" value={totalEntries} />
          <StatCard label="Total Weight" value={totalWeight.toFixed(2)} />
          <StatCard
            label="Approved"
            value={approvedCount}
            colorClass="green"
          />
          <StatCard
            label="Pending"
            value={pendingCount}
            colorClass="orange"
          />
          <StatCard
            label="Approval Rate"
            value={`${approvalRate.toFixed(1)}%`}
          />
          <StatCard
            label="Monthly Growth"
            value={`${growthPercentage.toFixed(1)}%`}
            colorClass={growthPercentage >= 0 ? "green" : "red"}
          />
        </div>
      </div>

      <ProductBreakdown breakdown={productBreakdown} />

      <RecentRecordsTable records={recentRecords} />
    </div>
  );
}

function ProfileHeader({ profile }) {
  const initials = (profile.fullname || "")
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0].toUpperCase())
    .slice(0, 2)
    .join("");

  const statusColorClass =
    profile.status === "Active" ? "green" : "gray";

  return (
    <div className="bg-white shadow-4 br3 pa4 flex items-center flex-wrap">
      {/* <div
        className="br-100 bg-light-blue flex items-center justify-center mr4 mb3-ns mb3"
        style={{ width: 72, height: 72, fontSize: 24, fontWeight: 600 }}
      >
        {initials}
      </div> */}

      <div className="flex-auto">
        <div className="flex items-center flex-wrap">
          <h1 className="f2 mb1 mr3">{profile.fullname}</h1>
          <span className={`f6 fw6 ttu ${statusColorClass} ba br-pill ph2 pv1`}>
            {profile.status}
          </span>
        </div>

        <div className="gray f6 mb1">
          {profile.username} &middot; {profile.category}
        </div>

        <div className="flex flex-wrap f6 mt2">
          <span className="mr4 mb1">
            <span className="gray">Company: </span>
            {profile.company}
          </span>
          <span className="mr4 mb1">
            <span className="gray">Email: </span>
            {profile.email}
          </span>
          <span className="mr4 mb1">
            <span className="gray">Phone: </span>
            {profile.phone}
          </span>
          <span className="mr4 mb1">
            <span className="gray">Gender: </span>
            {profile.gender}
          </span>
        </div>
      </div>
    </div>
  );
}

function StatCard({ label, value, colorClass = "" }) {
  return (
    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">{label}</div>
        <div className={`f2 fw6 ${colorClass}`}>{value}</div>
      </article>
    </div>
  );
}

function ProductBreakdown({ breakdown }) {
  if (breakdown.length === 0) {
    return null;
  }

  return (
    <div className="mt4">
      <h2 className="f3 mb3">Product Breakdown</h2>

      <div className="bg-white shadow-4 br3 pa3">
        <table className="w-100 collapse">
          <thead>
            <tr className="bb b--black-10">
              <th className="tl pa2 gray f6">Product</th>
              <th className="tr pa2 gray f6">Entries</th>
              <th className="tr pa2 gray f6">Weight</th>
            </tr>
          </thead>
          <tbody>
            {breakdown.map((item) => (
              <tr key={item.producttype} className="bb b--black-10">
                <td className="pa2 ttc">{item.producttype}</td>
                <td className="pa2 tr">{item.entries}</td>
                <td className="pa2 tr">{item.weight.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function RecentRecordsTable({ records }) {
  if (records.length === 0) {
    return null;
  }

  return (
    <div className="mt4">
      <h2 className="f3 mb3">Recent Records</h2>

      <div className="bg-white shadow-4 br3 pa3 overflow-auto">
        <table className="w-100 collapse">
          <thead>
            <tr className="bb b--black-10">
              <th className="tl pa2 gray f6">Date</th>
              <th className="tl pa2 gray f6">Product</th>
              <th className="tr pa2 gray f6">Weight</th>
              <th className="tl pa2 gray f6">Status</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record) => {
              const isApproved = record.approved_status === "approved";

              return (
                <tr key={record.id} className="bb b--black-10">
                  <td className="pa2">
                    {new Date(record.daterecorded).toLocaleDateString()}
                  </td>
                  <td className="pa2 ttc">{record.producttype}</td>
                  <td className="pa2 tr">{Number(record.weight).toFixed(2)}</td>
                  <td className="pa2">
                    <span
                      className={`f6 fw6 ttu br-pill ph2 pv1 ${
                        isApproved ? "green" : "orange"
                      }`}
                    >
                      {record.approved_status}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}